<template>
	<div class="star-container" :title="value" v-if="value > 0">
		<Star v-for="star in stars" :key="star.index" :shimmer="star.shimmer" :color="star.color" />
	</div>
	<div class="star-container" v-else>No data</div>
</template>

<script setup>
import { computed } from 'vue';
import Star from './svg/star.vue';

const props = defineProps({
	value: {
		type: Number,
		required: false,
	},
});

const stars = computed(() => {
	const totalStars = 5;
	const filledStars = Math.round(props.value || 0);

	return Array.from({ length: totalStars }, (_, index) => ({
		index,
		shimmer: index < filledStars,
		color: index < filledStars ? undefined : 'var(--gris-100)'
	}));
});
</script>

<style lang="scss" scoped>
.star-container {
	max-width: 250px;
	display: flex;
	gap: 0.5rem;
}
</style>